import type { Template } from "@/types";

export const LA_05_H4_V1: Template[] = [
    {
        id: "la-05-h4v1-01",
        name: "LA 01 - H4V1",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-05-h4_v1_01.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 67, y: 73, width: 542, height: 338, rotation: 0, imageRotation: 0 },      
            { id: "2", x: 796, y: 72, width: 171, height: 108, rotation: 0, imageRotation: 0 },
            { id: "3", x: 796, y: 188, width: 171, height: 107, rotation: 0, imageRotation: 0 },
            { id: "4", x: 796, y: 303, width: 171, height: 107, rotation: 0, imageRotation: 0 },
            { id: "5", x: 974, y: 72, width: 258, height: 338, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-05-h4v1-02",
        name: "LA 02 - H4V1",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-05-h4_v1_02.png",
        size: [1352, 483],
        style: {},
        slots: [        
            { id: "1", x: 65, y: 60, width: 269, height: 182, rotation: 0, imageRotation: 0 },
            { id: "2", x: 65, y: 250, width: 269, height: 182, rotation: 0, imageRotation: 0 },
            { id: "3", x: 342, y: 60, width: 269, height: 182, rotation: 0, imageRotation: 0 },
            { id: "4", x: 342, y: 250, width: 269, height: 182, rotation: 0, imageRotation: 0 },
            { id: "5", x: 883, y: 60, width: 255, height: 372, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-05-h4v1-03",
        name: "LA 03 - H4V1",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-05-h4_v1_03.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "4", x: 123, y: 76, width: 258, height: 162, rotation: 0, imageRotation: 0 },
            { id: "5", x: 123, y: 246, width: 258, height: 162, rotation: 0, imageRotation: 0 },
            { id: "1", x: 487, y: 0, width: 377, height: 483, rotation: 0, imageRotation: 0 },
            { id: "2", x: 971, y: 76, width: 258, height: 162, rotation: 0, imageRotation: 0 },
            { id: "3", x: 971, y: 246, width: 258, height: 162, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-05-h4v1-04",
        name: "LA 04 - H4V1",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-05-h4_v1_04.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 0, y: 161, width: 237, height: 162, rotation: 0, imageRotation: 0 },
            { id: "2", x: 244, y: 161, width: 236, height: 162, rotation: 0, imageRotation: 0 },
            { id: "3", x: 487, y: 0, width: 377, height: 483, rotation: 0, imageRotation: 0 },
            { id: "4", x: 873, y: 161, width: 237, height: 162, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1117, y: 161, width: 236, height: 162, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-05-h4v1-05",
        name: "LA 05 - H4V1",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-05-h4_v1_05.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 237, y: 40, width: 204, height: 129, rotation: 0, imageRotation: 0 },
            { id: "2", x: 131, y: 177, width: 204, height: 129, rotation: 0, imageRotation: 0 },
            { id: "3", x: 342, y: 177, width: 204, height: 129, rotation: 0, imageRotation: 0 },
            { id: "4", x: 237, y: 313, width: 204, height: 129, rotation: 0, imageRotation: 0 },
            { id: "5", x: 873, y: 40, width: 282, height: 402, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-05-h4v1-06",
        name: "LA 06 - H4V1",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-05-h4_v1_06.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 109, y: 47, width: 457, height: 292, rotation: 0, imageRotation: 0 },
            { id: "2", x: 109, y: 346, width: 147, height: 92, rotation: 0, imageRotation: 0 },     
            { id: "3", x: 264, y: 346, width: 147, height: 92, rotation: 0, imageRotation: 0 },
            { id: "4", x: 419, y: 346, width: 147, height: 92, rotation: 0, imageRotation: 0 },
            { id: "5", x: 876, y: 47, width: 276, height: 391, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-05-h4v1-07",
        name: "LA 07 - H4V1",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-05-h4_v1_07.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 201, y: 34, width: 301, height: 205, rotation: 0, imageRotation: 0 },
            { id: "2", x: 201, y: 246, width: 301, height: 204, rotation: 0, imageRotation: 0 },
            { id: "3", x: 509, y: 34, width: 334, height: 416, rotation: 0, imageRotation: 0 },
            { id: "4", x: 850, y: 34, width: 301, height: 205, rotation: 0, imageRotation: 0 },
            { id: "5", x: 850, y: 246, width: 301, height: 204, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-05-h4v1-08",
        name: "LA 08 - H4V1",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-05-h4_v1_08.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 46, y: 50, width: 581, height: 383, rotation: 0, imageRotation: 0 },
            { id: "2", x: 635, y: 50, width: 400, height: 245, rotation: 0, imageRotation: 0 },
            { id: "3", x: 635, y: 303, width: 196, height: 130, rotation: 0, imageRotation: 0 },
            { id: "4", x: 838, y: 303, width: 196, height: 130, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1042, y: 50, width: 264, height: 383, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-05-h4v1-09",
        name: "LA 09 - H4V1",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-05-h4_v1_09.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 46, y: 50, width: 400, height: 245, rotation: 0, imageRotation: 0 },
            { id: "2", x: 46, y: 303, width: 196, height: 130, rotation: 0, imageRotation: 0 },
            { id: "3", x: 250, y: 303, width: 196, height: 130, rotation: 0, imageRotation: 0 },
            { id: "4", x: 453, y: 50, width: 581, height: 383, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1042, y: 50, width: 264, height: 383, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-05-h4v1-10",
        name: "LA 10 - H4V1",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-05-h4_v1_10.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 46, y: 50, width: 264, height: 383, rotation: 0, imageRotation: 0 },
            { id: "2", x: 318, y: 50, width: 581, height: 383, rotation: 0, imageRotation: 0 },
            { id: "3", x: 906, y: 50, width: 196, height: 131, rotation: 0, imageRotation: 0 },
            { id: "4", x: 906, y: 189, width: 400, height: 244, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1110, y: 50, width: 196, height: 131, rotation: 0, imageRotation: 0 }
        ],
    }
];